export default {
      id: "icon-construction-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-construction",
      toString: function () {
        return this.url;
      }
    }